import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '800px',
    padding: '20px'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  }
};

Modal.setAppElement('#root');

function CompanyInfoModal({ isOpen, onClose, onSubmit, initialData }) {
  const [formData, setFormData] = useState({ ...initialData });

  useEffect(() => {
    setFormData(initialData || {});
  }, [initialData, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'businessRegistrationNumber') {
      const onlyDigits = value.replace(/[^\d]/g, '');
      let formatted = onlyDigits.substring(0, 10);
      if (formatted.length > 5) {
        formatted = `${formatted.slice(0, 3)}-${formatted.slice(3, 5)}-${formatted.slice(5)}`;
      } else if (formatted.length > 3) {
        formatted = `${formatted.slice(0, 3)}-${formatted.slice(3)}`;
      }
      setFormData(prev => ({ ...prev, [name]: formatted }));
    } else if (name === 'phoneNumber') {
        const onlyDigits = value.replace(/[^\d]/g, '');
        const len = onlyDigits.length;
        let formatted = onlyDigits;

        if (onlyDigits.startsWith('02')) { // Seoul
            if (len > 2 && len < 6) {
                formatted = `02-${onlyDigits.substring(2)}`;
            } else if (len >= 6 && len <= 9) {
                formatted = `02-${onlyDigits.substring(2, 5)}-${onlyDigits.substring(5)}`;
            } else if (len > 9) {
                formatted = `02-${onlyDigits.substring(2, 6)}-${onlyDigits.substring(6, 10)}`;
            }
        } else { // Other regions and mobile
            if (len > 3 && len < 7) {
                formatted = `${onlyDigits.substring(0, 3)}-${onlyDigits.substring(3)}`;
            } else if (len >= 7 && len <= 10) {
                formatted = `${onlyDigits.substring(0, 3)}-${onlyDigits.substring(3, 6)}-${onlyDigits.substring(6)}`;
            } else if (len > 10) {
                formatted = `${onlyDigits.substring(0, 3)}-${onlyDigits.substring(3, 7)}-${onlyDigits.substring(7, 11)}`;
            }
        }
        setFormData(prev => ({ ...prev, [name]: formatted }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={customStyles}>
      <div className="staff-modal-header">
        <h2>회사 정보 수정</h2>
      </div>
      <form onSubmit={handleSubmit} className="staff-modal-form" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <div style={{ display: 'flex', gap: '20px' }}>
          <div className="form-group" style={{ flex: 1 }}>
            <label>주소</label>
            <input type="text" name="address" value={formData.address || ''} onChange={handleChange} required />
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>이메일</label>
            <input type="email" name="email" value={formData.email || ''} onChange={handleChange} required />
          </div>
        </div>
        <div style={{ display: 'flex', gap: '20px' }}>
          <div className="form-group" style={{ flex: 1 }}>
            <label>사업자 번호</label>
            <input type="text" name="businessRegistrationNumber" value={formData.businessRegistrationNumber || ''} onChange={handleChange} required />
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>전화번호</label>
            <input type="text" name="phoneNumber" value={formData.phoneNumber || ''} onChange={handleChange} required />
          </div>
        </div>
        <div className="staff-modal-footer">
          <button type="submit" className="submit-btn">저장</button>
          <button type="button" onClick={onClose} className="cancel-btn">취소</button>
        </div>
      </form>
    </Modal>
  );
}

export default CompanyInfoModal;
